import { IIncidentReport } from '@nkr/models/index';

export interface IRowData extends IIncidentReport {
    isSelected: boolean
}